module.exports = __webpack_public_path__ + "static/media/sun-haze.14085e01.svg";